const VolumeCap = {
  DAY: "day",
  EntireCampaign: "campaign",
};

export default VolumeCap;
